module.exports = __webpack_public_path__ + "75907af0ce890d82a11c3a0ab9453b1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images/round@2x.png
// module id = 312
// module chunks = 0